import { render } from "./GriotBuilderView.vue?vue&type=template&id=f0475f12&scoped=true"
import script from "./GriotBuilderView.vue?vue&type=script&lang=js"
export * from "./GriotBuilderView.vue?vue&type=script&lang=js"

import "./GriotBuilderView.vue?vue&type=style&index=0&id=f0475f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0475f12"]])

export default __exports__